import { Button } from '@insta-club/ui';

type StepNavigatorProps = {
    isFirst: boolean;
    isLast: boolean;
    onPrev: () => void;
    onNext: () => void;
    nextDisabled: boolean;
    isLoading?: boolean;
};

const StepNavigator = ({ isFirst, isLast, onPrev, onNext, nextDisabled, isLoading }: StepNavigatorProps) => (
    <div className='mt-6 flex justify-between gap-3'>
        {!isFirst ? (
            <Button className='w-1/2' type='button' onClick={onPrev} color='gray' disabled={isLoading}>
                مرحله قبل
            </Button>
        ) : (
            <div />
        )}
        <Button
            className='w-1/2'
            type='button'
            onClick={onNext}
            disabled={nextDisabled || isLoading}
            loading={isLoading}
        >
            {isLast ? 'ارسال نهایی' : 'مرحله بعد'}
        </Button>
    </div>
);

export default StepNavigator;

